'use client'

export const loadSessionStorageState = (key: string) => {
  try {
    if (typeof window !== 'undefined') {
      const serializeState = sessionStorage.getItem(key)
      if (serializeState === null) {
        return undefined
      }
      return JSON.parse(serializeState)
    }
  } catch (error) {
    console.error('Err:Utils: Session Storage load save:', error)
  }
}

export const saveSessionStorageState = (key: string, state: any) => {
  try {
    if (typeof window !== 'undefined') {
      const serializeState = JSON.stringify(state)
      sessionStorage.setItem(key, serializeState)
    }
  } catch (error) {
    console.error('Err:Utils: Session Storage state save:', error)
  }
}

export const removeSessionStorageState = (key: string) => {
  try {
    if (typeof window !== 'undefined') {
      sessionStorage.removeItem(key)
    }
  } catch (error) {
    console.error('Err:Utils: Session Storage state remove:', error)
  }
}

export const resetSessionStorageState = () => {
  try {
    if (typeof window !== 'undefined') {
      sessionStorage.clear()
    }
  } catch (error) {
    console.error('Err:Utils: Session Storage state save:', error)
  }
}
